"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TertiaryButtonLink = exports.TertiaryButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const primary_1 = require("./primary");
exports.TertiaryButton = (0, styled_1.default)(primary_1.PrimaryButton) `
  &&& {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary')};
    &:focus,
    &:hover {
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_hover')};
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_hover')};
    }
    &:disabled {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_disabled')};
      cursor: not-allowed;
    }
  }
`;
exports.TertiaryButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.TertiaryButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=tertiary.js.map